"use strict";

module.exports = require("./stateSource");


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/stateSource/index.js
 ** module id = 505
 ** module chunks = 0
 **/